import { GAME_ID, PUBLIC_BASE_URL, HEADERS } from '@config/game.js'
import i18n from '@plugins/localisation.js'
import { authStore } from '@stores'
import axios from 'axios'

export function create() {
  axios.defaults.baseURL = PUBLIC_BASE_URL
  axios.defaults.headers.get['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.common['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.delete['Content-Type'] =
    'application/x-www-form-urlencoded'
  axios.defaults.headers.common['Accept'] = 'application/json'

  return axios
}

function _setHeaders(config) {
  const { accessTokens, getUserLanguage } = authStore()

  if (accessTokens.value[GAME_ID]) {
    if (config.anonymous !== true) {
      config.headers.Authorization = `Bearer ${accessTokens.value[GAME_ID]}`
    }
  }

  config.headers['Accept-Language'] =
    i18n.global.locale.value || getUserLanguage()

  if (HEADERS.portal) {
    config.headers['X-Modio-Portal'] = HEADERS.portal
  }
  if (HEADERS.platform) {
    config.headers['X-Modio-Platform'] = HEADERS.platform
  }

  if (config.external !== true) {
    config.headers['X-Modio-Origin'] = 'web'
  }

  return config
}

axios.interceptors.request.use(function (config) {
  config = _setHeaders(config)
  return config
})
